import { render, staticRenderFns } from "./OnboardingPage.vue?vue&type=template&id=6efe3960&scoped=true"
import script from "./OnboardingPage.vue?vue&type=script&lang=js"
export * from "./OnboardingPage.vue?vue&type=script&lang=js"
import style0 from "./OnboardingPage.vue?vue&type=style&index=0&id=6efe3960&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efe3960",
  null
  
)

export default component.exports